<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 18:48:59
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-09 20:06:53
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/components/HeaderSearch/index.vue
-->
<template>
  <header>
    <el-form inline size="mini" :model="seachFormData">
      <el-row>
        <el-col>
          <el-form-item>
            <el-select v-model="seachFormData.type" placeholder="请选择" size="mini">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item>
            <el-input size="mini" prefix-icon="el-icon-search" placeholder="请输入关键词搜索你想要的内容"
              v-model="seachFormData.keyWord">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col>
          <el-form-item style="margin-right:0">
            <el-button size="mini" @click="resetHandel">重置</el-button>
            <el-button type="primary" size="mini" @click="inquireHeader" style="background:#1A7BFC;margin-left: 20px">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </header>
</template>
<script>
import { apiDoctorTeam, apiDepartmentTreeList } from "../../api";
import { plateFormAll } from "@/api/acc.js";
export default {
  name: "HeaderSeract",
  props: {
    fromDataValue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: [
        {
          label: "姓名",
          value: 1
        },
        {
          label: "微信名",
          value: 2
        },
        {
          label: "手机号",
          value: 3
        },
        {
          label: "证件号",
          value: 4
        }
      ],
      organizationList: [], //归属平台列表
      seachFormData: {
        type: 1,
        keyWord: "", //模糊查询字段
      },
      userFromList: [
        //来源渠道
        {
          name: "医生",
          id: "1"
        },
        {
          name: "护士",
          id: "2"
        },
        {
          name: "地推",
          id: "3"
        },
        {
          name: "其他",
          id: "4"
        }
      ],
      wholeCourseTypeList: [
        //病程分类列表
        {
          name: "是",
          id: 1
        },
        {
          name: "否",
          id: 2
        }
      ],
      doctorTeamList: [], //医护团队列表
      caseMgrGroupList: [] //疗程主管列表
    };
  },
  watch: {
    fromDataValue: {
      handler(val) {
        this.seachFormData = val;
      },
      deep: true
    }
  },
  mounted() {
    //TODO init为true来判断是否第一次加载
    this.init();
    this.$emit("inquire", { ...this.seachFormData });
  },
  methods: {
    /**
     * @description: 重置通知
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.seachFormData = {
        ...this.seachFormData,
        keyWord: "",
        type: 1
      };
      this.$emit("reset", this.seachFormData);
    },

    /**
     * @description: 查询通知
     * @param {*}
     * @return {*}
     */
    inquireHeader() {
      const param = this.seachFormData;
      this.$emit("inquire", param);
    },

    /**
         * @description: 加载全部配置项接口
         * @param {*}
         * @return {*}
        //  */
    init() {
      //归属平台下拉列表筛选项
      this.organizationList = [];
      plateFormAll().then(res => {
        if (res.code == 0) {
          res.data.map(item => {
            if (item.name !== "平台") {
              this.organizationList.push(item);
            }
          });
        }
      });

      //医护团队列表查询
      apiDoctorTeam().then(res => {
        if (res.code == 0) {
          this.doctorTeamList = res.data;
        }
      });

      //疗程主管查询
      apiDepartmentTreeList({
        type: 2
      }).then(res => {
        if (res.code == 0) {
          this.caseMgrGroupList = res.data;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
header {
  .el-form {
    // margin-bottom: 13px;
    .el-col-24 {
      width: auto !important;
      .from-width {
        width: 97px;
      }
    }
    .el-form-item {
      margin-right: 20px;
    }
  }
  .el-form-item__content {
    & /deep/ .el-button:focus,
    .el-button:hover {
      // color: #1A7BFC !important;
      border-color: #1a7bfc !important;
      // background-color: #1A7BFC !important;
    }
  }
}
</style>